import { DashboardLocaleKeysProvider } from '../../assets/locale/auto-generated/dashboardLocaleKeys';
import { useTranslate } from 'react-admin';

export function LocalizationProvider({ children }: { children: any }) {
    const translate = useTranslate();
    return <DashboardLocaleKeysProvider translateFn={translate as any}>{children}</DashboardLocaleKeysProvider>;
}
